export enum OrganizationCheckStatus {
  ORGANIZATION_NOT_FOUND = "ORGANIZATION_NOT_FOUND",
  ORGANIZATION_FOUND_EMPLOYEE = "ORGANIZATION_FOUND_EMPLOYEE",
  ORGANIZATION_FOUND_NOT_EMPLOYEE = "ORGANIZATION_FOUND_NOT_EMPLOYEE",
  PERSONAL_INN_HAS_COMPANY = "PERSONAL_INN_HAS_COMPANY",
  PERSONAL_INN_HAS_NO_COMPANY = "PERSONAL_INN_HAS_NO_COMPANY",
  ORGANIZATION_APPLICATION_ALREADY_REJECTED = "ORGANIZATION_APPLICATION_ALREADY_REJECTED"
}

export interface OrganizationCheckResponse {
  result: OrganizationCheckStatus;
  text: string;
  orgnizationName: string | null;
}
